export const formatApiError = (error, fallbackMessage = 'Something went wrong') => {
  const apiMessage = error?.response?.data?.error;
  const details = error?.response?.data?.details;
  const message = apiMessage || details || error?.message || fallbackMessage;

  if (!message) {
    return fallbackMessage;
  }

  if (
    message.includes('uq_enrollment_student_batch') ||
    message.includes('Duplicate entry') ||
    message.toLowerCase().includes('already enrolled')
  ) {
    return 'This student is already enrolled in the selected batch.';
  }

  return message;
};
